/* eslint array-callback-return: 0 */
import {createAction} from 'redux-actions';
import {INVALIDATE_USER} from '../config/const';
import { isDelivery as isDeliveryAvailable, isPickup } from '../selectors/configSelectors';
import { toBool } from './configReducer';


const SHOW_ADDRESS_BAR = 'SHOW_ADDRESS_BAR';
const HIDE_ADDRESS_BAR = 'HIDE_ADDRESS_BAR';
const ADD_PICKUP_ADDRESSES = 'ADD_PICKUP_ADDRESSES';
const SET_PICKUP_ADDRESSES = 'SET_PICKUP_ADDRESSES';
const ADD_DELIVERY_ADDRESSES = 'ADD_DELIVERY_ADDRESSES';
const SET_DELIVERY_ADDRESSES = 'SET_DELIVERY_ADDRESSES';
const SET_DELIVERY_ADDR_IDX = 'SET_DELIVERY_ADDR_IDX';
const SET_PICKUP_ADDR_IDX = 'SET_PICKUP_ADDR_IDX';
const RESET_ADDRESS = 'RESET_ADDRESS';
const SET_DELIVERY_BY_ID = 'SET_DELIVERY_BY_ID';
const SET_PICKUP_BY_ID = 'SET_PICKUP_BY_ID';

export const reset = createAction(RESET_ADDRESS);
export const showAddressBar = createAction(SHOW_ADDRESS_BAR);
export const hideAddressBar = createAction(HIDE_ADDRESS_BAR);
/* add array of addresses */
export const addPickupAddresses = createAction(ADD_PICKUP_ADDRESSES);
/* set array of addresses, for first initialization */
export const setPickupAddresses = createAction(
  SET_PICKUP_ADDRESSES,
  addresses => addresses
);
export const addDeliveryAddresses = createAction(
  ADD_DELIVERY_ADDRESSES,
  addresses => addresses
);
export const setDeliveryAddresses = createAction(
  SET_DELIVERY_ADDRESSES,
  addresses => addresses
);
export const setDelivery = createAction(
  SET_DELIVERY_ADDR_IDX,
  deliveryAddrIndex => deliveryAddrIndex
);
export const setDeliveryById = createAction(SET_DELIVERY_BY_ID, id => id);
export const setPickupById = createAction(SET_PICKUP_BY_ID, id => id);
export const setPickup = createAction(
  SET_PICKUP_ADDR_IDX,
  pickupAddrIndex => pickupAddrIndex
);

const initialState = {
  isAddressBarOpen: true,
  isDelivery: false,
  pickUpAddresses: [],
  deliveryAddresses: [],
  currentAddressIdx: -1
};
const addressReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_ADDRESS_BAR: {
    return {
      ...state,
      isAddressBarOpen: true
    };
  }
  case HIDE_ADDRESS_BAR: {
    return {
      ...state,
      isAddressBarOpen: false
    };
  }
  case SET_PICKUP_ADDRESSES: {
    return {
      ...state,
      pickUpAddresses: action.payload
    };
  }
  case ADD_PICKUP_ADDRESSES: {
    return {
      ...state,
      pickUpAddresses: [...state.pickUpAddresses, ...action.payload]
    };
  }
  case SET_DELIVERY_ADDRESSES: {
    if (action.payload.length === 0) {
      return {
        ...state,
        deliveryAddresses: action.payload,
        currentAddressIdx: -1
      };
    }
    return {
      ...state,
      deliveryAddresses: action.payload
    };

  }
  case ADD_DELIVERY_ADDRESSES: {
    return {
      // ...state, deliveryAddresses: [...state.deliveryAddresses, ...action.payload], isDelivery: true, currentAddressIdx: state.deliveryAddresses.length
      ...state,
      deliveryAddresses: [...state.deliveryAddresses, ...action.payload]
    };
  }
  case SET_DELIVERY_ADDR_IDX: {
    return {
      ...state,
      isDelivery: true,
      currentAddressIdx: action.payload
    };
  }
  case SET_DELIVERY_BY_ID: {
    let addrIndex = -1;
    state.deliveryAddresses.map((item, index) => {
      if (item.address.id === action.payload) addrIndex = index;
    });
    return {
      ...state,
      isDelivery: true,
      currentAddressIdx: addrIndex
    };
  }
  case SET_PICKUP_BY_ID: {
    let addrIndex = -1;
    state.pickUpAddresses.map((item, index) => {
      if (item.address.id === action.payload) addrIndex = index;
    });
    return {
      ...state,
      isDelivery: false,
      currentAddressIdx: addrIndex
    };
  }
  case SET_PICKUP_ADDR_IDX: {
    return {
      ...state,
      isDelivery: false,
      currentAddressIdx: action.payload
    };
  }
  case INVALIDATE_USER:
  case RESET_ADDRESS: {
    return {
      ...state,
      deliveryAddresses: [],
      currentAddressIdx: -1
    };
  }
  default: {
    return state;
  }
  }
};

export const isCustomerDeliveryTypeProfile = state => state.address.isDelivery;
export const isDelivery = state => toBool(isDeliveryAvailable(state)) && isCustomerDeliveryTypeProfile(state);

export const currentAddress = state => {
  if (state.address.currentAddressIdx === -1) return '';

  if (
    toBool(isDeliveryAvailable(state)) &&
    state.address.deliveryAddresses.length > 0 &&
    state.address.isDelivery &&
    state.address.currentAddressIdx > -1
  ) {
    return (
      state.address.deliveryAddresses[state.address.currentAddressIdx] &&
      state.address.deliveryAddresses[state.address.currentAddressIdx].address
    );
  }

  if (isPickup(state)) {
    const _address =
    state.address.pickUpAddresses[state.address.currentAddressIdx];
    // TODO ADD address placeholder
    // problem - error when primary address was deleted
    if (!_address) return '';
    const address = _address.address;
    return {...address, dispensaryName: _address.dispensaryName};
  }
  return undefined;
};

export const getCurrentAddressIdx = state => state.address.currentAddressIdx;
export const isAddressBarOpened = state => state.config.isEcommerceEnabled && state.address.isAddressBarOpen;
export const getDeliveryAddresses = state => state.address.deliveryAddresses;
export const isPickUpAvailable = state => state.address.pickUpAddresses.length > 0;

export const getDeliveryAddressNote = state => {
  const isDelivery = state.address.isDelivery;

  if (!isDelivery) return '';
  const idx = state.address.currentAddressIdx;
  const comment = state.address.deliveryAddresses[idx] && state.address.deliveryAddresses[idx].address && state.address.deliveryAddresses[idx].address.comment;
  return comment || '';
};
export const getDirection = state => {
  if (state.address.pickUpAddresses.length > 0) {
    const address = state.address.pickUpAddresses[0].address;
    return (
      `${address.street
      }, ${
        address.city
      }, ${
        address.state
      }, ${
        address.country}`
    );
  }
};
export const getDirectionPlaceId = state => {
  if (state.address.pickUpAddresses.length > 0) {
    const address = state.address.pickUpAddresses[0].address;
    return address.placeId;
  }
};
export const isAddressSelected = state => {
  return (isCustomerDeliveryTypeProfile(state) === isDeliveryAvailable(state) || !isCustomerDeliveryTypeProfile(state) === isPickup(state)) && 
    state.address.currentAddressIdx > -1;
}

export default addressReducer;



// WEBPACK FOOTER //
// ./src/reducers/addressReducer.js